import { ValidationLevel, ValidationResults } from 'Automations/nodeDefinitions'

type FlattenedValidationResult = {
  key: string
  nodeId: string
  fieldId: string
  title: string
  message: string
  level: ValidationLevel
}

export const flattenValidationResults = (
  validationResults: ValidationResults
): FlattenedValidationResult[] => {
  return Object.keys(validationResults)
    .flatMap(nodeId => {
      return Object.keys(validationResults[nodeId]).flatMap(fieldId => {
        return validationResults[nodeId][fieldId].map(
          ({ title, message, level }, index) => {
            return {
              key: `${nodeId}:${fieldId}:${index}`,
              nodeId,
              fieldId,
              title,
              message,
              level
            }
          }
        )
      })
    })
    .filter((result): result is FlattenedValidationResult => Boolean(result))
}
